import { MARQUEE_ITEMS } from "../data";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-line bg-parchment2 py-4 overflow-hidden"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee gap-0">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-lg sm:text-xl text-ink2 px-6">{item}</span>
            <span className="text-terra text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
